// store/thunks/auth/forgotPassword.ts

import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { normalizeEmail } from '@/utils/strings/strings';

export const forgotPasswordThunk = createAdminAsyncThunk<
  undefined,
  { emailAddress: string },
  { rejectValue: { message: string } }
>('auth/forgotPassword', async({ emailAddress }, { extra: { authService }, rejectWithValue }) => {
  try {
    await authService.forgotPassword({ emailAddress: normalizeEmail(emailAddress) });
  } catch (caught) {
    const message =
      caught instanceof Error ? caught.message : 'Failed to send reset password email';
    return rejectWithValue({ message });
  }
});
